import PlatformType from '@/commons/wildcards/constants/PlatformType';

export default {
  ConfigInfo(state) {
    return state.ConfigInfo;
  },
  CurrentDate(state) {
    return state.ConfigInfo.CurrentDate;
  },
  Context(state) {
    return state.Context;
  },
  /**
   * Kiểm tra đơn vị có đang chạy trên nền tảng MISA Platform (MPL) mới hay không
   */
  IsMplPlatform(state) {
    return (
      (state.Context?.PlatformType == PlatformType.IHOSPlatform ||
        state.Context?.PlatformType == PlatformType.IGOVPlatform) &&
      state.Context?.PlatformVersion == 2
    );
  },
  NumberFormat(state) {
    return state.NumberFormat;
  },
  Culture(state) {
    return state.Context.Culture;
  },
  OptionsData(state) {
    return state.OptionsData;
  },
  Token(state) {
    return state.Token;
  },
  Loading(state) {
    return state.Loading;
  },
  User(state) {
    return state.User;
  },
  Permission(state) {
    return state.Permission;
  },
  LeftMenuCollapse(state) {
    return state.LeftMenuCollapse;
  },
  Culture(state) {
    return state.Culture;
  },
  PostedDate(state) {
    return state.PostedDate;
  },
  FiscalStartDate(state) {
    return state.FiscalStartDate;
  },
  IsDisabledConvert(state) {
    return state.IsDisabledConvert;
  },
  IsDisabledBusyDatabase(state) {
    return state.IsDisabledBusyDatabase;
  },
  DatabaseConverting(state) {
    return state.DatabaseConverting;
  },
  LastConvertQueue(state) {
    return state.LastConvertQueue;
  },
  ConvertProgress(state) {
    return state.ConvertProgress;
  },
  DatabaseConvertError(state) {
    return state.DatabaseConvertError;
  },
  LastTimeConvert(state) {
    return state.LastTimeConvert;
  },
  TenantDatabases(state) {
    return state.TenantDatabases;
  },
  DatabaseId(state) {
    return state.DatabaseId;
  },
  TenantId(state) {
    return state.TenantId;
  },
  BudgetCode(state) {
    return state.BudgetCode;
  },
  NearExpiredDate(state) {
    return state.NearExpiredDate;
  },
  NumberOfDayNearExpired(state) {
    return state.NumberOfDayNearExpired;
  },
  NumberOfDayExpired(state) {
    return state.NumberOfDayExpired;
  },
  SubscriberNo(state) {
    return state.SubscriberNo;
  },
  ShowWarningDate(state) {
    return state.Context.ShowWarningDate;
  },
  ShowWarningDateTop(state) {
    return state.Context.ShowWarningDateTop;
  },
  ShowWarningDateTopClient(state) {
    return state.Context.ShowWarningDateTopClient;
  },
  DeviceId(state) {
    return state.Context.DeviceId;
  },
  IsAdmin(state) {
    return state.IsAdmin;
  },
  DatabaseRestoring(state) {
    return state.DatabaseRestoring;
  },
  DatabaseBackuping(state) {
    return state.DatabaseBackuping;
  },
  NumberFromSUMAN(state) {
    return state.Context.NumberFromSUMAN;
  },
  TenantName(state) {
    return state.Context.TenantName;
  },
  UserName(state) {
    return state.Context.UserName;
  },
  IsManagermentSource(state) {
    return state.Context.isManagermentSource;
  },
  UserID(state) {
    return state.Context.UserID;
  },
  IsMultipleTenant(state) {
    return state.Context.isMultipleTenant;
  },
  CreateDataProcess(state) {
    return state.CreateDataProcess;
  },
  GroupId(state) {
    return state.GroupId;
  },
  BackUpSuccess(state) {
    return state.BackUpSuccess;
  },
  StatusCircular(state) {
    return state.StatusCircular;
  },
  CopyDataProgress(state) {
    return state.CopyDataProgress;
  },
  DatabaseCopyData(state) {
    return state.DatabaseCopyData;
  },
  SortRefNoResult(state) {
    return state.SortRefNoResult;
  },
  StatusCircularTT76(state) {
    return state.StatusCircularTT76;
  },
  NewFeatureZoom(state) {
    return state.NewFeatureZoom;
  },
  HelpSettlemenZoom(state) {
    return state.HelpSettlemenZoom;
  },
  VersionNewFeature(state) {
    return state.VersionNewFeature;
  },
  IsCheckOverUser(state) {
    return state.IsCheckOverUser;
  },
  UseOffline(state) {
    return state.UseOffline;
  },
  HasLicenseFromSuman(state) {
    return state.HasLicenseFromSuman;
  },
  MISANotifyHeader(state) {
    return state.MISANotifyHeader;
  },
  MISAAgreementPurchase(state) {
    return state.MISAAgreementPurchase;
  },
  IsPressChatbot(state) {
    return state.IsPressChatbot;
  },
  CreateDataType(state) {
    return state.CreateDataType;
  },
};
